<script lang="ts">
    import NowPlayingInfo from '~/components/structure/Players/components/NowPlayingInfo/NowPlayingInfo.svelte';
    import NowPlayingQueue from '~/components/structure/Players/components/NowPlayingQueue/NowPlayingQueue.svelte';
    import { openDrawer, DrawerKind } from '~/stores/open-drawer';

    // TODO: rdar://140938579 ([Classical on Web] - Info - Sidebar)
    // export let showFullScreenPlayer: boolean;
</script>

<NowPlayingInfo
    on:toggleOpen={({ detail: isOpen }) =>
        ($openDrawer = isOpen ? DrawerKind.Info : null)}
    isOpen={$openDrawer === DrawerKind.Info}
    componentType={'sidebar'}
    isMobileView={false}
/>

<NowPlayingQueue
    on:toggleOpen={({ detail: isOpen }) =>
        ($openDrawer = isOpen ? DrawerKind.UpNext : null)}
    isOpen={$openDrawer === DrawerKind.UpNext}
    componentType={'sidebar'}
    isMobileView={false}
/>
